import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApi } from "../api";
import { useAuth } from "../auth";
import "./login.css";

/*
 * Sign in – port of index.php, with password reset by SMS code from login_assist.php.
 * After signing in you go where index.php sent your role (stationery staff to the service desk, others to the dashboard).
 */

export default function Login() {
  const api = useApi();
  const { login, notice } = useAuth();
  const navigate = useNavigate();
  const [mode, setMode] = useState("login"); // login | forgot | reset
  const [f, setF] = useState({ username: "", password: "" });
  const [show, setShow] = useState(false);
  const [r, setR] = useState({ username: "", user_id: null, otp: "", new_password: "", confirm_password: "" });
  const [msg, setMsg] = useState(notice ? { tone: "warn", text: notice } : null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setMsg(null);
    try { const to = await login(f.username.trim(), f.password); navigate(to || "/dashboard", { replace: true }); }
    catch (err) { setMsg({ tone: "err", text: err.message }); setBusy(false); }
  };
  const sendCode = async (e) => {
    e.preventDefault(); setBusy(true); setMsg(null);
    try { const x = await api.post("/api/auth/otp", { username: r.username.trim() }); setR({ ...r, user_id: x.user_id }); setMode("reset"); setMsg({ tone: "ok", text: x.message }); }
    catch (err) { setMsg({ tone: "err", text: err.message }); }
    finally { setBusy(false); }
  };
  const reset = async (e) => {
    e.preventDefault(); setBusy(true); setMsg(null);
    try {
      const x = await api.post("/api/auth/reset", r);
      setMode("login"); setF({ username: r.username, password: "" }); setMsg({ tone: "ok", text: x.message });
    } catch (err) { setMsg({ tone: "err", text: err.message }); }
    finally { setBusy(false); }
  };

  return (
    <div className="lg-wrap">
      <div className="lg-side" aria-hidden="true">
        <div className="lg-mark"><i className="fas fa-store" /></div>
        <h2>AE2C Enterprise</h2>
        <p>Point of sale, stock, finance and people, in one place.</p>
      </div>
      <main className="lg-card">
        <div className="lg-brand"><span className="lg-logo"><i className="fas fa-store" /></span><div><b>AE2C Enterprise</b><small>Mini Market ERP</small></div></div>
        {mode === "login" && (<>
          <h1>Sign in</h1><p className="lg-sub">Use your AE2C username and password.</p>
          {msg && <div className={`lg-msg ${msg.tone}`} role={msg.tone === "err" ? "alert" : "status"}>{msg.text}</div>}
          <form onSubmit={submit}>
            <label htmlFor="lg-u">Username</label>
            <input id="lg-u" autoComplete="username" autoFocus required value={f.username} onChange={(e) => setF({ ...f, username: e.target.value })} />
            <label htmlFor="lg-p">Password</label>
            <div className="lg-pw"><input id="lg-p" type={show ? "text" : "password"} autoComplete="current-password" required value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} />
              <button type="button" onClick={() => setShow(!show)} aria-label={show ? "Hide password" : "Show password"}><i className={`fas ${show ? "fa-eye-slash" : "fa-eye"}`} /></button></div>
            <button type="submit" className="lg-btn" disabled={busy}>{busy ? "Signing in…" : "Sign in"}</button>
          </form>
          <button type="button" className="lg-link" onClick={() => { setMode("forgot"); setMsg(null); setR({ ...r, username: f.username }); }}>Forgot password?</button>
        </>)}
        {mode === "forgot" && (<>
          <h1>Reset password</h1><p className="lg-sub">We'll send a 6-digit code to the phone number on your account.</p>
          {msg && <div className={`lg-msg ${msg.tone}`} role="alert">{msg.text}</div>}
          <form onSubmit={sendCode}>
            <label htmlFor="rs-u">Username</label>
            <input id="rs-u" required autoFocus value={r.username} onChange={(e) => setR({ ...r, username: e.target.value })} />
            <button type="submit" className="lg-btn" disabled={busy}>{busy ? "Sending…" : "Send code"}</button>
          </form>
          <button type="button" className="lg-link" onClick={() => { setMode("login"); setMsg(null); }}>Back to sign in</button>
        </>)}
        {mode === "reset" && (<>
          <h1>Enter the code</h1><p className="lg-sub">The code is valid for 10 minutes.</p>
          {msg && <div className={`lg-msg ${msg.tone}`} role={msg.tone === "err" ? "alert" : "status"}>{msg.text}</div>}
          <form onSubmit={reset}>
            <label htmlFor="rs-c">6-digit code</label>
            <input id="rs-c" inputMode="numeric" autoComplete="one-time-code" maxLength={6} required autoFocus value={r.otp} onChange={(e) => setR({ ...r, otp: e.target.value.replace(/\D/g, "") })} />
            <label htmlFor="rs-n">New password</label>
            <input id="rs-n" type="password" autoComplete="new-password" minLength={6} required value={r.new_password} onChange={(e) => setR({ ...r, new_password: e.target.value })} />
            <label htmlFor="rs-k">Confirm new password</label>
            <input id="rs-k" type="password" autoComplete="new-password" minLength={6} required value={r.confirm_password} onChange={(e) => setR({ ...r, confirm_password: e.target.value })} />
            <button type="submit" className="lg-btn" disabled={busy}>{busy ? "Saving…" : "Set new password"}</button>
          </form>
          <button type="button" className="lg-link" onClick={() => { setMode("forgot"); setMsg(null); }}>Send a new code</button>
        </>)}
      </main>
    </div>
  );
}
